import TradingList from './TradingList';

export default TradingList;
